import React from "react";

export default class TextBlock extends React.Component {
    constructor(props) {
        super ( props );
        this.state = {
            lang : this.props.lang
        }
    }


    render() {
        return (

            <div className={this.props.className + " text-block"}>
                <p>{this.props.text}</p>
            </div>
        )
    }
}



